import { Pencil } from 'lucide-react';

/** Subtle pencil icon shown next to a sidebar label. The parent button is the click target. */
const EditLink = () => (
	<Pencil
		className="w-3 h-3 text-muted-foreground/60 group-hover:text-muted-foreground transition-colors shrink-0"
		aria-hidden="true"
	/>
);

export default EditLink;
